import * as React from 'react'
type Props = {
  errors: Record<string, ReadonlyArray<string>>
  map: Map<string, string>
}

const ErrorList = ({ errors, map }: Props): React.ReactElement<'ul'> => {
  const errorMessages: string = Object.keys(errors)
    .map(key => `<li>${map.get(key) || key}: ${errors[key].join('. ')}.</li>`)
    .join('')
  return (
    <ul
      dangerouslySetInnerHTML={{
        __html: errorMessages || '<li>Controleer wat je hebt ingevuld en probeer het daarna opnieuw.</li>',
      }}
    />
  )
}

export default ErrorList